import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CreateEventModal from 'modules/events/components/CreateEvent/CreateEventModal';
import Box from 'yoda-ui/components/Box';
import Button from 'yoda-ui/components/Button';
import { ButtonType } from 'yoda-ui/components/Button/Button.types';
import Icon, { Icons } from 'yoda-ui/components/Icons/Icon';

const CreateEvent: FC = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <Box>
      <Button
        buttonType={ ButtonType.secondary }
        onClick={ () => setOpen(true) }
      >
        <Icon name={ Icons.addCircle } fontSize="small" />
        { t('event_creation_modal_button_label') }
      </Button>
      <CreateEventModal open={ open } setOpen={ setOpen } />
    </Box>
  );
};

export default CreateEvent;
